export default __webpack_public_path__ + "static/3-cd57ac4f96d69d2df66096ad00e8e7ca.jpeg";